import { InputAdornment, TextField } from "@mui/material";
import { GetData } from "contexts/DataContext";
import React from "react";

import { Box } from "@mui/system";

export default function FieldBlock(props) {
  const { dataObj } = GetData();
  const elRef = React.useRef(null);

  return (
    <React.Fragment>
      <Box
        {...props?.sx}
        sx={{
          // overflow: "auto",

          alignItems: "flex-start",
          background: "transparent",
          boxShadow: "none",
          // margin: "0.4rem 1rem",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box
          id={props?.label}
          sx={{
            alignItems: "flex-start",
            justifyContent: "space-between",
            // margin: "0.5rem 1rem",
            width: "100%",
          }}
        >
          <TextField
            InputProps={{
              endAdornment: props?.endIcon ? (
                <InputAdornment
                  position="end"
                  sx={
                    {
                      // marginLeft: props?.iconMargin ? props?.iconMargin : "-12px",
                    }
                  }
                >
                  {props?.endIcon}
                </InputAdornment>
              ) : undefined,
              pattern: props?.pattern ? props?.pattern : undefined,
              startAdornment: props?.icon ? (
                <InputAdornment
                  position="start"
                  sx={
                    {
                      // marginLeft: props?.iconMargin ? props?.iconMargin : "-12px",
                    }
                  }
                >
                  {props?.icon}
                </InputAdornment>
              ) : undefined,
              style: {
                fontSize: dataObj?.deviceWidth?.isMobile ? "0.875rem" : "1rem",
              },
            }}
            disabled={props.disabled ? props.disabled : undefined}
            error={
              props.error
                ? props.error
                : props.required
                ? !props.value
                : undefined
            }
            fullWidth={true}
            helperText={props.helperText ? props.helperText : undefined}
            inputProps={{
              maxLength: props?.length ? props?.length : undefined,
              style: {
                textTransform:
                  props?.label === "plate"
                    ? "lowercase"
                    : props?.label === "vin"
                    ? "uppercase"
                    : undefined,
              },
            }}
            inputRef={elRef}
            label={props?.title}
            mb={2}
            mt={2}
            name={props?.label}
            onBlur={
              props?.onBlurFunc
                ? (e) => props?.onBlurFunc(e.target.value)
                : undefined
            }
            onChange={(e) =>
              props.setValue(
                props?.disableUpperCase
                  ? e.target.value.toUpperCase()
                  : e.target.value
              )
            }
            onKeyPress={
              props?.onBlurFunc
                ? (e) => {
                    if (e.key === "Enter") {
                      elRef.current.blur();
                      // elRef.current.blur();
                      // props?.onBlurFunc(e.target.value);
                    }
                  }
                : undefined
            }
            placeholder={props.placeholder ? props.placeholder : undefined}
            type={props?.type ? props?.type : "text"}
            value={props.value}
            variant="standard"
          />
        </Box>
        <Box sx={{ marginTop: "18px" }}>{props?.component}</Box>
      </Box>
    </React.Fragment>
  );
}
